import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { startRegistration, startAuthentication } from "@simplewebauthn/browser";
import { api, type PasskeyInfo } from "../lib/api";

// Login por passkey (Face ID / Touch ID). Pré-sessão: pede o desafio, dispara a
// cerimônia WebAuthn no navegador, e verifica. No sucesso o backend seta o cookie
// jpv_sess; invalidamos ["session"] pra o AuthGate reavaliar (espelha AuthVerify).
export const useLoginPasskey = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const optionsJSON = await api.auth.passkey.loginOptions();
      const response = await startAuthentication({ optionsJSON });
      return api.auth.passkey.loginVerify(response);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["session"] }),
  });
};

// Registro de passkey — exige sessão ativa (bootstrap via login-link ou magic link).
export const useRegisterPasskey = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (deviceName?: string) => {
      const optionsJSON = await api.auth.passkey.registerOptions();
      const response = await startRegistration({ optionsJSON });
      return api.auth.passkey.registerVerify(response, deviceName);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["passkeys"] }),
  });
};

export const usePasskeys = () =>
  useQuery<PasskeyInfo[]>({
    queryKey: ["passkeys"],
    queryFn: () => api.auth.passkey.list(),
    staleTime: 60_000,
  });

export const useRemovePasskey = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (credentialId: string) => api.auth.passkey.remove(credentialId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["passkeys"] }),
  });
};
